import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { TypeEntityTypes } from '@pf/shared-common';
import { EquipmentTypeRead } from '../../entities/equipment-type.dto';

@Injectable()
export class EquipmentTypeStore extends AbstractEntityStore<EquipmentTypeRead> {
    constructor() {
        super(TypeEntityTypes.WarehouseEquipmentType);
    }
}
